import React, { memo, useEffect, useCallback, useState} from 'react';
import DurationIndicator from './DurationIndicator.js';
import {getBarLength} from 'utils/getBarLength.js';
import StepData from 'pattern/StepData.js';
import StepToggle from "components/cirklon/StepToggle.js"

import ParameterEditor from './ParameterEditor.js';
import {connect} from 'react-redux';

const DEFAULT_STEP_DATA = new StepData();

const CirklonStep = memo(({
    track,
    resolution,
    parameter,
    stepData=DEFAULT_STEP_DATA,
    on,
    i,
    stepNumber,
    isCursor,
    isSelected,
    color}) => { 
        if (stepData === undefined) {
            return [];
        }

        let prefix = '';
        let barLength = getBarLength(resolution);
        if (stepNumber % barLength === 0 && i !== 0) {
            prefix = (<div className="bar-divider"></div>);
        }
        let className = on ? "cirklon-step on" : "cirklon-step";
        if (isCursor) {
            className += " cursor";
        }
        return [
            prefix,
            <div
              data-stepNumber={stepNumber}
              className={className}>
              <ParameterEditor
                color={color}
                trackParameter={track.trackData.parameters.find(x => x.name===parameter) || track.trackData.velocityParameter}
                track={track}
                stepData={stepData}
                parameter={stepData.parameters.find(x => x.name===parameter) || stepData.velocityParameter}/>
              <DurationIndicator color={color} stepData={stepData}/>
              <StepToggle
                color={color}
                isSelected={isSelected}
                track={track}
                on={on}
                stepData={stepData}
                stepNumber={stepNumber}/>
            </div>];
    });

export default CirklonStep;
